import React, { useState } from 'react'
import { Button, Col, Form, Image, message, Modal, Row, Upload, Typography, Flex } from 'antd'
import { MyDatepicker, MyInput, MySelect, MySingleFileUpload } from '../../PageComponents';
import { CloseCircleOutlined } from '@ant-design/icons';
import { apiCalls } from '../../../shared/Apis';
import moment from 'moment';

const { Dragger } = Upload
const { Title } = Typography
const AddAppointmentModal = ({visible,onClose, form, professionalID}) => {

    const [ showaddress, setShowAddress ] = useState(false)
    const [ loading, setLoading ] = useState(false)
    const handleChange = (e) => {
        setShowAddress(e === 1 ? true : false)
    } 

    const createQuote = async () => {
        setLoading(true);
        let data = form.getFieldsValue()
        const formdata = new FormData()
        formdata.append("dateOfProject",  data?.dateOfProject)
        formdata.append("budgetMin", data?.budgetMin)
        formdata.append("budgetMax", data?.budgetMax)
        formdata.append("date", moment(data?.date).format('YYYY-MM-DD'))
        formdata.append("type", data?.type)
        formdata.append("description", data?.description)
        formdata.append("message", data?.message)
        formdata.append("professionalID", professionalID)
        const servicesIDArray = data?.servicesID || [];
        const formattedServicesID = JSON.stringify(servicesIDArray);
        formdata.append("servicesID", formattedServicesID);
        if(data?.image)
            formdata.append("image", data?.image)
        let result= await apiCalls?.getquoteApi?.createQuote(formdata)
        setLoading(false)
        if(result)
            form.resetFields()
            onClose()
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
    }

  return (
    <div>
        <Modal 
            title={null}
            centered
            open={visible} 
            onCancel={onClose}
            closeIcon={false}
            className='modal-cs'
            footer={
                <Flex justify='end' gap={5}>
                    <Button className="btn-cancel" onClick={onClose}>
                        Cancel
                    </Button>
                    <Button className="btn" 
                        loading={loading}
                        onClick={()=>form.submit()}
                    >
                        Confirm
                    </Button>
                </Flex>
            }
            width={600}
        >
            <div className='header-modal1 position-relative'>
                <Flex justify='space-between' align='center'>
                    <Title level={4} className='m-0'>
                        Set an appointment
                    </Title>
                    <Button className='border0 bg-transparent p-0' onClick={onClose}>
                        <CloseCircleOutlined  style={{fontSize: 20}} />
                    </Button>
                </Flex>
            </div>
            <div className='content-modal'>
                <Form 
                    form={form}
                    layout='vertical'
                    requiredMark={false}
                    onFinish={createQuote}
                >
                    <Row gutter={[16, 16]}>
                        <Col span={24}>
                            <MySingleFileUpload
                                name='image'
                                label='Upload image'
                                required
                                message='please upload image'
                                form={form}
                            />
                        </Col>
                        <Col span={24}>
                            <MySelect 
                                label='Type of appointment'
                                name='type'
                                required
                                message='Please choose an appointment type'
                                onChange={handleChange}
                                options={[
                                    {
                                        id: 1,
                                        name: 'Message'
                                    },
                                    {
                                        id: 2,
                                        name: 'In person'
                                    }
                                ]}
                            />
                        </Col>
                        <Col span={24}>
                            <MyDatepicker
                                datePicker 
                                label='Date'
                                name='date'
                                required
                                message='Please enter date'
                                placeholder=''
                            />
                        </Col>
                        {
                            showaddress && 
                            <Col span={24}>
                                <MyInput 
                                    label='Work Address'
                                    name='message'
                                    required
                                    message='Please enter work address'
                                    placeholder=''
                                    row={6}
                                />
                            </Col>
                        }
                    </Row>
                </Form>
            </div>
        </Modal>
    </div>
  )
}

export {AddAppointmentModal}